let AsyncLoadCoupons = {
    start: function () {
        const $couponsSliderBlock = $('#allCouponsSliderBlock');
        if ($couponsSliderBlock.length) {
            $couponsSliderBlock.asyncLoad(function () {
                if (typeof Coupons !== 'undefined') {
                    Coupons.bindCouponCardActionEvents(flyerCouponClipUrl, flyerCouponUnclipBaseUrl, replaceContainerAfterClipUnclip, closeModalAndRefreshContent);
                    if (typeof isFlyerPageRequest != 'undefined' && isFlyerPageRequest) {
                        templateSlick($('.couponsListSlick'), 1, 2, 4, false);
                    } else {
                        templateSlick($('.couponsListSlick'), 1, 2, 3, false);
                    }
                    function replaceContainerAfterClipUnclip(data) {
                        $('#couponsSliderContent').html(data);
                        if (typeof isFlyerPageRequest != 'undefined' && isFlyerPageRequest) {
                            templateSlick($('.couponsListSlick'), 1, 2, 4, false);
                        } else {
                            templateSlick($('.couponsListSlick'), 1, 2, 3, false);
                        }
                        Coupons.bindCouponCardActionEvents(flyerCouponClipUrl, flyerCouponUnclipBaseUrl, replaceContainerAfterClipUnclip, closeModalAndRefreshContent);
                    }

                    function closeModalAndRefreshContent(data) {
                        $('#coupon-detail-modal-open').removeClass('in-progress');
                        $('#closeCouponsModal').click();
                        replaceContainerAfterClipUnclip(data)
                    }
                }

                // Initialize detail modals for coupons
                $('[data-remodal-id^="modal-coupon-legal"]').remodal();
            });
        }
    }
}